import { createActionGroup, props } from '@ngrx/store';
import { Transfer, CreateTransferDto, CashHandoffDto } from '../../models/transfer.model';

export const TransfersActions = createActionGroup({
  source: 'Transfers',
  events: {
    'Load Transfers': props<{ personnelId?: number }>(),
    'Load Transfers Success': props<{ transfers: Transfer[] }>(),
    'Load Transfers Failure': props<{ error: string }>(),
    'Create Transfer': props<{ dto: CreateTransferDto }>(),
    'Create Transfer Success': props<{ transfer: Transfer }>(),
    'Create Transfer Failure': props<{ error: string }>(),
    'Cash Handoff': props<{ dto: CashHandoffDto }>(),
    'Cash Handoff Success': props<{ transfer: Transfer }>(),
    'Cash Handoff Failure': props<{ error: string }>(),
  }
});
